import { render, staticRenderFns } from "./EmbraceInfo.vue?vue&type=template&id=9b577184"
import script from "./EmbraceInfo.vue?vue&type=script&lang=js"
export * from "./EmbraceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports